import ReactGA4 from "react-ga4";
import { getConsent } from "./utils/consent";

let initialized = false;

const InitializeGoogleAnalytics = () => {
  if (initialized || getConsent() !== true) {
    return;
  }
  const tracking_id = process.env.REACT_APP_GA_MESUREMENT_ID;
  if (!tracking_id) {
    console.error("GA tracking ID is not set");
    return;
  }
  ReactGA4.initialize(tracking_id);
  initialized = true;
  ReactGA4.send({
    hitType: "pageview",
    page: "/home",
    title: "biotechnofix",
  });
};
const trackPageview = (url) => {
  if (!initialized) return;
  ReactGA4.send({ hitType: "pageview", page: url });
};
const TrackGoogleAnalyticsEvent = (category, action) => {
  if (!initialized) return;
  ReactGA4.event({
    category: category,
    action: action,
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, trackPageview, TrackGoogleAnalyticsEvent };
